export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("ttl_admin_token");
export const setToken = (token) => localStorage.setItem("ttl_admin_token", token);
export const clearToken = () => localStorage.removeItem("ttl_admin_token");

export const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
});

export const formatApiError = (detail, fallback = "Something went wrong. Please try again.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || fallback;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
